<template>
	<div class="c-teaser-block">
		<h3>{{ teaserData.title }}</h3>
		<a class="c-teaser-block__contactlink" :href="teaserData.link_url" v-if="teaserData.link_text && teaserData.link_url">
			{{ teaserData.link_text }}
		</a>
	</div>
</template>

<script>
export default {
	name: 'teaser-block',
	props: ['teaserData'],
}
</script>

<style lang="scss">

@import '../assets/css/helpers';

$m: 'c-teaser-block';

.#{$m} {
	text-align: center;
	padding: 3rem 1rem;
	background-color: $colorGrayLight;
	margin-top: 4rem;

	h3 {
		font-size: 1.75rem;
		font-weight: 600;
		max-width: 800px;
		margin: 0 auto;
		margin-bottom: 3rem;
	}

	&__contactlink {
		display: block;
		text-decoration: none;
		font-size: .9rem;
		border: 4px solid $colorBrandSecondary;
		width: 12rem;
		height: 2.5rem;
		line-height: 2.5rem;
		font-weight: 600;
		box-sizing: content-box;
		margin: 0 auto;

		&:hover {
			border-color: $colorBrandMain;
			background-color: #fff;
		}
	}

	@include mq($from: medium) {
		h3 {
			font-size: 3rem;
		}
	}
}

</style>



// WEBPACK FOOTER //
// TeaserBlock.vue?23cef50a